<template>
     <div class="main-wrapper">
     <v-header v-if="isMobile"></v-header>
      <div class="main-container" v-bind:class="{contentBoxMobile: isMobile}">
        <v-sidebar></v-sidebar>
        <div class="content-box" :style='isCollapse ? "left: 64px" : ""' >
          <v-header v-if="!isMobile"></v-header>
          <v-tags></v-tags>
          <head-top></head-top>
          <div class="content">
            <!-- <transition name="move" mode="out-in" > -->
              <keep-alive >
                <router-view v-if="$route.meta.keepActive"></router-view>
              </keep-alive>
              <router-view v-if="!$route.meta.keepActive"></router-view>
            <!-- </transition> -->
            <!-- <transition name="move" mode="out-in" >
              <keep-alive>
                <router-view ></router-view>
              </keep-alive>
            </transition> -->
            <!-- <keep-alive :include="tagsList">
                <router-view ></router-view>
              </keep-alive> -->
          </div>
      </div>
    </div>
  </div>

</template>
<script type="text/ecmascript-6">
import vHeader from './Header.vue';
import vSidebar from './sidebar';
import vTags from './Tags.vue';
import bus from './bus';
import headTop from './headTop.vue';
import ResizeMixin from './mixin/ResizeHandler';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      tagsList: ['commentCount','needsComment'],
      collapse: false
    };
  },
  components: {
    vHeader, vSidebar, vTags, headTop
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters(['isMobile','isCollapse'])
  },
  created () {
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', msg => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
    //  this.tagsList = arr;
    // console.log(arr)
    });
  }
};
</script>

<style scoped>
  .header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
  }
  .collapse-btn{
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
  }
  .header .logo{
    float: left;
    width:250px;
    line-height: 70px;
  }
  .header-right{
    float: right;
    padding-right: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Layout/index.vue